import { render, staticRenderFns } from "./BaseRealname.vue?vue&type=template&id=6867c99a&scoped=true&"
import script from "./BaseRealname.vue?vue&type=script&lang=js&"
export * from "./BaseRealname.vue?vue&type=script&lang=js&"
import style0 from "./BaseRealname.vue?vue&type=style&index=0&id=6867c99a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6867c99a",
  null
  
)

export default component.exports